import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { taches, messageErreur } from '../services/api';
import { BadgePriorite, Chargement, Erreur, Panneau } from './communs';
import { ChampsTache } from './Formulaires';
import MurActivite from './MurActivite';
import PiecesJointes from './PiecesJointes';
import { horodatage, nomComplet } from '../utils/format';

/**
 * Fiche d'une tâche dans le panneau latéral : champs modifiables puis mur
 * d'activité. `onModifie` prévient la page appelante (kanban à rafraîchir).
 */
export default function FicheTache({ tacheId, moi, utilisateurs, onFermer, onModifie, lienProjet }) {
  const [tache, setTache] = useState(null);
  const [v, setV] = useState(null);
  const [erreur, setErreur] = useState(null);
  const [message, setMessage] = useState(null);
  const [envoi, setEnvoi] = useState(false);
  const [version, setVersion] = useState(0); // relance le mur après un enregistrement

  useEffect(() => {
    setTache(null); setErreur(null); setMessage(null);
    taches.detail(tacheId)
      .then((t) => { setTache(t); setV(t); })
      .catch((e) => setErreur(messageErreur(e)));
  }, [tacheId]);

  const maj = (p) => { setV((x) => ({ ...x, ...p })); setMessage(null); };
  const modifiee = tache && v && ['titre', 'description', 'statut', 'priorite', 'assigne_id', 'date_debut', 'date_echeance']
    .some((k) => (tache[k] || null) !== (v[k] || null));

  async function enregistrer() {
    if (!v.titre.trim()) return setErreur('Le titre est obligatoire.');
    setEnvoi(true); setErreur(null);
    try {
      const t = await taches.modifier(tache.id, v);
      setTache(t); setV(t); setMessage('Modifications enregistrées.');
      setVersion((x) => x + 1);
      onModifie?.();
    } catch (e) {
      setErreur(messageErreur(e));
    } finally {
      setEnvoi(false);
    }
  }

  async function supprimer() {
    if (!window.confirm(`Supprimer la tâche « ${tache.titre} » et son mur d’activité ? C’est définitif.`)) return;
    try {
      await taches.supprimer(tache.id);
      onModifie?.();
      onFermer();
    } catch (e) {
      setErreur(messageErreur(e));
    }
  }

  const entete = tache ? (
    <>
      <div className="fil-ariane">
        {lienProjet
          ? <Link to={`/projets/${tache.projet_id}?tache=${tache.id}`}>{tache.projet_nom}</Link>
          : <span className="doux">{tache.projet_nom}</span>}
        {tache.entreprise_nom && <> · <span className="doux">{tache.entreprise_nom}</span></>}
      </div>
      <input
        className="titre-editable"
        aria-label="Titre de la tâche"
        value={v.titre}
        onChange={(e) => maj({ titre: e.target.value })}
      />
      <div className="projet-infos" style={{ marginTop: 6 }}>
        <BadgePriorite priorite={tache.priorite} />
        <span>créée par <b>{nomComplet(tache, 'createur_') || '—'}</b> le {horodatage(tache.created_at)}</span>
      </div>
    </>
  ) : <strong>Tâche</strong>;

  return (
    <Panneau titre={tache ? tache.titre : 'Tâche'} onFermer={onFermer} entete={entete}>
      {erreur && <Erreur>{erreur}</Erreur>}
      {!tache && !erreur && <Chargement />}
      {tache && (
        <>
          {message && <div className="succes-bandeau">{message}</div>}
          <div className="panneau-section">
            <ChampsTache valeurs={v} maj={maj} utilisateurs={utilisateurs} sansTitre />
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <button type="button" className="btn btn-danger btn-petit" onClick={supprimer}>Supprimer la tâche</button>
              <span style={{ flex: 1 }} />
              {modifiee && <button type="button" className="btn" onClick={() => setV(tache)}>Annuler</button>}
              <button type="button" className="btn btn-primaire" onClick={enregistrer} disabled={!modifiee || envoi}>
                {envoi ? 'Enregistrement…' : 'Enregistrer'}
              </button>
            </div>
          </div>
          <PiecesJointes tacheId={tache.id} onChange={() => setVersion((x) => x + 1)} />
          <MurActivite tacheId={tache.id} moi={moi} utilisateurs={utilisateurs} majTache={version} />
        </>
      )}
    </Panneau>
  );
}
